import {listTypes} from './enum';
import {APIActionStatus, formsStore} from '../../../../stores/Form';
import {EntityType} from '../../consts/EntityTypes';
import {actionZoom} from '../../actions/zoom';
import {startDirectActivation} from '../../actions/activations';

export type OptionType = {
    value: string;
    label: string;
    data: {
        action: () => Promise<APIActionStatus | void>;
        type?: number | Long;
    };
};
export const mapListDataByType = (listType: listTypes, runInSearchMode: boolean): OptionType[] => {
    const {getActiveForm, currentScreen} = formsStore;
    const currentForm = getActiveForm();

    if (!currentForm) return [];

    if (listType === listTypes.FormSons) {
        return (
            currentForm?.subFormsList.map(item => ({
                label: item.Title,
                value: item.Ename,
                data: {
                    action: async () => {
                        return await currentScreen.runSubForm(
                            item.Ename,
                            currentForm,
                            item.IsText,
                            runInSearchMode
                        );
                    }
                }
            })) || []
        );
    } else if (listType === listTypes.DirectActivations) {
        return (
            currentForm?.actions.map(item => ({
                label: item.Title,
                value: item.Exec.toString(),
                data: {
                    type: item.Type,
                    action: async () => {
                        startDirectActivation(currentForm, item);
                    }
                }
            })) || []
        );
    } else if (listType === listTypes.DirectActivationsF) {
        return (
            currentForm?.actions
                .map(item => ({
                    label: item.Title,
                    value: item.Ename,
                    data: {
                        type: item.Type,
                        action: async () => {
                            await actionZoom(currentForm, item.Ename);
                        }
                    }
                }))
                .filter(item => item.data.type === EntityType.FORM) || []
        );
    }
    return [];
};

export const formHasActiveKeys = () => {
    const currentForm = formsStore.getActiveForm();
    if (currentForm && !currentForm.searchModeLevel) {
        const activeRow = currentForm.records[currentForm.currentRow];
        return activeRow?.keys;
    }
    return false;
};
